// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__wteAY","notFoundIcon":"NotFound_notFoundIcon__EQSg7","homeButton":"NotFound_homeButton__DZ6HD"};